module.exports = __webpack_public_path__ + "static/media/11.874d1c61.mp3";